import { render, staticRenderFns } from "./Investigator.vue?vue&type=template&id=0f9268e6&scoped=true&"
import script from "./Investigator.vue?vue&type=script&lang=js&"
export * from "./Investigator.vue?vue&type=script&lang=js&"
import style0 from "./Investigator.vue?vue&type=style&index=0&id=0f9268e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9268e6",
  null
  
)

export default component.exports